// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1QO-V","content":"Consent_content__313c8","footer":"Consent_footer__2Lfwp"};